import React from 'react'
import '../../style.css'
import styles from './CommonBanner.module.scss'
import { Box, Divider, Grid, Typography, useMediaQuery } from '@mui/material'
import img from '../../asserst/img/Otusone banner.png'
import HowWeWork from '../HowWeWork/HowWeWork'

const CommonBanner = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const isTablet = useMediaQuery('(max-width:1024px)');

  return (
    <Grid className={styles.commonBannerContainer}>
      <Grid className={styles.commonBanner}>
        {/* Background Image */}
        <Grid className={styles.bgImg}>
          <img src={img} alt="Otusone Banner" />
        </Grid>

        {/* Overlay */}
        <Grid className={styles.bgOpicity}></Grid>

        {/* Content */}
        <Grid className={styles.content}>
          <Box>
            <Typography
              variant="h1"
              className={styles.heading}
              sx={{
                fontSize: isMobile ? "1.6rem" : isTablet ? "2.2rem" : "3rem",
                lineHeight: isMobile ? "2rem" : isTablet ? "2.8rem" : "3.5rem",
                fontWeight: 700,
              }}
            >
              Let us handle the IT, so you can focus on soaking up the sunshine
            </Typography>

            <Typography
              className={styles.subText}
              sx={{
                fontSize: isMobile ? "0.85rem" : isTablet ? "1rem" : "1.15rem",
                width: isMobile ? "100%" : "80%",
                margin: "auto",
              }}
            >
              "Crafting Cutting-Edge Solutions for Your Business" encapsulates our commitment to delivering
              innovative and tailored IT services that propel your business forward. At OTUSONE LLP
            </Typography>
          </Box>
        </Grid>
      </Grid>

      {/* Section below Banner */}
      {!isMobile && <HowWeWork />}
      <Divider sx={{ marginBlock: 3 }} />
    </Grid>
  )
}

export default CommonBanner
